import get from 'lodash/get'
import { diff } from 'jsondiffpatch'
import { format as formatJsonPatch } from 'jsondiffpatch/formatters/jsonpatch'
import { match } from 'ts-pattern'

export const getPresentationChanges = (
  before: unknown,
  after: unknown
): PresentationChange[] => {
  const delta = diff(before, after)

  if (!delta) {
    return []
  }

  return formatJsonPatch(delta).map(operation =>
    match(operation)
      .with({ op: 'add' }, ({ path }) => ({
        path: formatChangePath(path),
        before: undefined,
        after: get(after, jsonPointerSegments(path))
      }))
      .with({ op: 'remove' }, ({ path }) => ({
        path: formatChangePath(path),
        before: get(before, jsonPointerSegments(path)),
        after: undefined
      }))
      .with({ op: 'replace' }, ({ path }) => ({
        path: formatChangePath(path),
        before: get(before, jsonPointerSegments(path)),
        after: get(after, jsonPointerSegments(path))
      }))
      .with({ op: 'move' }, ({ from, path }) => ({
        path: `${formatChangePath(from)} -> ${formatChangePath(path)}`,
        before: get(before, jsonPointerSegments(from)),
        after: get(after, jsonPointerSegments(path))
      }))
      .exhaustive()
  )
}

type PresentationChange = {
  path: string
  before: unknown
  after: unknown
}

const jsonPointerSegments = (path: string): string[] =>
  path
    .split('/')
    .slice(1)
    .map(segment => segment.replaceAll('~1', '/').replaceAll('~0', '~'))

const formatChangePath = (path: string): string =>
  jsonPointerSegments(path).reduce(
    (formattedPath, segment) =>
      /^\d+$/.test(segment)
        ? `${formattedPath}[${segment}]`
        : [formattedPath, segment].filter(Boolean).join('.'),
    ''
  )
